import { CollectionListStatus } from '@/types'

export interface CreateCollectionListRequest {
  name: string
  nameKana: string
  status: CollectionListStatus
  releaseStartDate: string
  releaseEndDate: string
  unlimitedFlag: boolean
  priority: number | null
  bibliographies: {
    bibliographyRealId: number
    rank: number
  }[]
}

export function CreateCollectionListRequestToJSON(
  value: CreateCollectionListRequest
): any {
  return {
    name: value.name !== '' ? value.name : undefined,
    name_kana: value.nameKana !== '' ? value.nameKana : undefined,
    status: value.status ?? undefined,
    release_start_date:
      value.releaseStartDate !== '' ? value.releaseStartDate : undefined,
    release_end_date:
      value.releaseEndDate !== '' ? value.releaseEndDate : undefined,
    unlimited_flag: value.unlimitedFlag ?? undefined,
    priority: value.priority ?? undefined, // 0で登録もあり得る
    bibliographies:
      value.bibliographies.length > 0
        ? value.bibliographies.map(bibliography => {
            return {
              bibliography_real_id:
                bibliography.bibliographyRealId !== 0
                  ? bibliography.bibliographyRealId
                  : undefined,
              rank: bibliography.rank !== 0 ? bibliography.rank : undefined
            }
          })
        : undefined
  }
}
